import api from "../services/api";
import _ from "lodash";
import moment from "moment-timezone";
import Utils from "@/core/utils/utils";

const parseChartResponse = (response, payload) => {
  const colors = {
    PricingTool: "#7bc0f8",
    VarianceTable: "#555cce",
    LucidComm: "#19cb59",
    Lookup: "#9c44d3",
  };
  let byTotal = {};
  let byDuration = {};
  response.data.forEach((i) => {
    byTotal[i.product] = [];
    byDuration[i.product] = [];
  });

  let groupedLabel = _.groupBy(response.data, "grouped_date");

  const labels = genDefaultLabel(payload.type);

  labels.forEach((v) => {
    // eslint-disable-next-line complexity
    Object.keys(byTotal).forEach((p) => {
      if (!groupedLabel[v.toJSON()]) {
        byTotal[p].push(0);
        byDuration[p].push(0);
      } else {
        const item = groupedLabel[v.toJSON()].find((i) => i.product === p);
        byTotal[p].push(item ? +item.total : 0);
        byDuration[p].push(item ? +item.duration : 0);
      }
    });
  });

  return {
    label: genLabel(labels, payload.type),
    datasetsTotal: Object.entries(byTotal).map(([key, value]) => {
      return {
        label: key,
        data: value,
        borderColor: colors[key] || "#62778f",
        backgroundColor: colors[key] || "#62778f",
      };
    }),
    datasetsDuration: Object.entries(byDuration).map(([key, value]) => {
      return {
        label: key,
        data: value,
        borderColor: colors[key] || "#62778f",
        backgroundColor: colors[key] || "#62778f",
      };
    }),
  };
};

// eslint-disable-next-line complexity
const genLabel = (label, type) => {
  let format = "";
  switch (true) {
    case ["lastHour", "last3Hours", "last6Hours", "last24Hours"].includes(type):
      format = "HH:mm";
      break;
    case ["last3Days", "last7Days", "last15Days"].includes(type):
      format = "DD HH:mm";
      break;
    case ["last30Days", "lastYear"].includes(type):
      format = "DD/MM";
      break;
  }

  return label.map((i) => moment(i).tz("America/Los_Angeles").format(format));
};

// eslint-disable-next-line complexity
const genDefaultLabel = (type) => {
  let date = null;
  let result = [];
  let endDate = null;
  let currentDate = null;

  switch (type) {
    case "lastHour":
      currentDate = moment().startOf("minutes").utc(false);
      endDate = currentDate.toDate();
      date = currentDate.subtract(1, "hour").toDate();
      break;
    case "last3Hours":
      currentDate = moment().startOf("minutes").utc(false);
      endDate = currentDate.toDate();
      date = currentDate.subtract(3, "hour").toDate();
      break;
    case "last6Hours":
      currentDate = moment().startOf("minutes").utc(false);
      endDate = currentDate.toDate();
      date = currentDate.subtract(6, "hour").toDate();
      break;
    case "last24Hours":
      currentDate = moment().startOf("minutes").utc(false);
      endDate = currentDate.toDate();
      date = currentDate.subtract(24, "hour").toDate();
      break;
    case "last3Days":
      currentDate = moment().startOf("hours").utc(false);
      endDate = currentDate.toDate();
      date = currentDate.subtract(2, "days").toDate();
      break;
    case "last7Days":
      currentDate = moment().startOf("hours").utc(false);
      endDate = currentDate.toDate();
      date = currentDate.subtract(7, "days").toDate();
      break;
    case "last15Days":
      currentDate = moment().startOf("hours").utc(false);
      endDate = currentDate.toDate();
      date = currentDate.subtract(15, "days").toDate();
      break;
    case "last30Days":
      currentDate = moment().startOf("day");
      endDate = currentDate.toDate();
      date = currentDate.subtract(29, "days").toDate();
      break;
    case "lastYear":
      currentDate = moment().startOf("month");
      endDate = currentDate.toDate();
      date = currentDate.subtract(1, "year").toDate();
      break;
  }

  if (["lastHour", "last3Hours", "last6Hours", "last24Hours"].includes(type)) {
    while (date < endDate) {
      date = Utils.addMinutes(date, 1);
      result.push(date);
    }
  } else if (["last3Days", "last7Days", "last15Days"].includes(type)) {
    while (date < endDate) {
      date = Utils.addHours(date, 1);
      result.push(date);
    }
  } else if (["last30Days"].includes(type)) {
    while (date < endDate) {
      date = Utils.addDay(date, 1);
      result.push(moment(date).utc(true).toDate());
    }
  } else if (["lastYear"].includes(type)) {
    while (date < endDate) {
      date = Utils.addMonth(date, 1);
      result.push(moment(date).utc(true).toDate());
    }
  }

  return result;
};

export default {
  actions: {
    loadRealtimeReport({ commit }, payload) {
      return api
        .loadRealtimeReport(payload)
        .then((response) => parseChartResponse(response, payload));
    },
  },
  namespaced: true,
};
